export default __webpack_public_path__ + "static/media/seta-baixo-outline.f3af0e80.svg";